import {Oui_TypeOuiNonInformComplementaire} from './Oui_TypeOuiNonInformComplementaire';
export class TypeOuiNonInformComplementaire {

	public oui: Oui_TypeOuiNonInformComplementaire;

	public non: string;

	public autresInformComplementaire: string;

	constructor() { 
		 		this.oui = new Oui_TypeOuiNonInformComplementaire();
		this.non = '';
		this.autresInformComplementaire = '';
 
	}
}
